<div class="raw main">
    <div class="col-12">
        <div class="col-3 left" *ngIf="Data && SearchHide == false">
            <div id="scrollfix">
                <label>買主搜尋</label>
                <buyer-select (ChangeEvt)="BuyerTemp($event)"
                 [Countries]="buyerCountries" [Industries]="buyerindustries"></buyer-select>

                 <div class="btn" (click)="AddToTag()">加入搜尋條件</div>

                 <div class="checkbox">
                     <label for="c1">隱藏「取消來台」買主</label>
                     <label class="switch">
                         <input type="checkbox" (change)="BuyerEvt($event)"/>
                         <span class="slider round"></span>
                      </label>
                 </div>
            </div>
        </div>
        <div class="col-9 right">
            <div class="activity animated fadeIn" *ngIf="Data">
                <div class="status {{Status.class}}"><span>{{Status.name}}</span></div>
                <h1>{{Data.name}}</h1>
                <p class="time">
                    <i class="icon icon-clock">&#xe80d;</i>{{Data.eventFullDateTime}}
                </p>
                <p class="addr">
                    <i class="icon icon-web">&#xe805;</i>{{Data.location}} 
                    <a *ngIf="Map != ''" href="{{Map}}" target="_blank">
                        <span class="map"><i class="icon icon-map">&#xe804;</i>地圖</span>
                    </a>
                </p>

                <ng-container *ngIf="itemHide && Data.infoItems">
                    <div class="item">
                        <label>{{Data.infoItems[0].name}}</label>
                        <p [innerHtml]="Data.infoItems[0].description"></p>
                    </div>
                    <div class="item">
                        <label>{{Data.infoItems[1].name}}</label>
                        <p class="litmit" [innerHtml]="Data.infoItems[1].description"></p>
                        <span class="showall" (click)="Open()">更多</span>
                    </div>
                </ng-container>
                <ng-container *ngIf="!itemHide && Data.infoItems">
                    <ng-container *ngFor="let item of Data.infoItems">
                        <div class="item animated fadeIn">
                            <label>{{item.name}}</label>
                            <p [innerHtml]="item.description"></p>
                        </div>
                    </ng-container>
                </ng-container>
                
                
            </div>

            <!-- 不列分類 -->
            <div class="search" *ngIf="!buyerByCategory && BuyerData">
                <h1 *ngIf="BuyerData.length > 1" class="pageSelect">
                    買主列表
                    <label>
                        <span>共有 {{TotalRows}} 筆結果</span>
                        <select [(ngModel)]="pageSize" (change)="SetPerpage()">
                            <option [value]="30">每頁顯示30筆</option>
                            <option [value]="50">每頁顯示50筆</option>
                            <option [value]="100">每頁顯示100筆</option>
                        </select>
                    </label>
                </h1>
                <div class="term" style="margin-bottom: 1.5rem;">
                    <ng-container *ngFor="let item of TagGroup;let _g = index;">
                        <div *ngIf="item.tag.length > 0" class="tag {{ (_g == 0) ? 'first' : '' }}" >
                            <label>{{item.name}}</label>
                            <p>
                                <ng-container *ngFor="let _child of item.tag;">
                                    <label>{{_child.name}}<i class="icon icon-close" (click)="RemoveTag(_child.tag_index)">&#xe802;</i></label>
                                </ng-container>
                            </p>
                        </div>
                    </ng-container>
                </div>

                <div class="content">
                    <ng-container *ngFor="let item of BuyerData">
                        <buyerCard [Data]="item"></buyerCard>
                    </ng-container>
                    <pagination *ngIf="BuyerPager" [Pager]="BuyerPager" (PageSetEvt)="SetBuyerPage($event)"></pagination>
                </div>
            </div>
     
            <!-- 列分類 -->
            <div class="search" *ngIf="buyerByCategory && BuyerData">
                <h1 *ngIf="BuyerData.length > 1" class="pageSelect">
                    買主列表
                    <label>
                        <span>共有 {{TotalRows}} 筆結果</span>
                        <select [(ngModel)]="pageSize" (change)="SetPerpage()">
                            <option [value]="30">每頁顯示30筆</option>
                            <option [value]="50">每頁顯示50筆</option>
                            <option [value]="100">每頁顯示100筆</option>
                        </select>
                    </label>
                </h1>
                <div class="term" style="margin-bottom: 1.5rem;">
                    <ng-container *ngFor="let item of TagGroup;let _g = index;">
                        <div *ngIf="item.tag.length > 0" class="tag {{ (_g == 0) ? 'first' : '' }}" >
                            <label>{{item.name}}</label>
                            <p>
                                <ng-container *ngFor="let _child of item.tag;">
                                    <label>{{_child.name}}<i class="icon icon-close" (click)="RemoveTag(_child.tag_index)">&#xe802;</i></label>
                                </ng-container>
                            </p>
                        </div>
                    </ng-container>
                </div>

                <div class="content">
                    <ng-container *ngFor="let item of BuyerData;let _index = index;">
                        <ng-container *ngIf="_index == 0">
                            <ng-container *ngIf="item.industry">
                                <h2>{{item.industry.name}}</h2>
                            </ng-container>
                            <buyerCard [Data]="item"></buyerCard>
                        </ng-container>
                        <ng-container *ngIf="_index > 0">
                            <ng-container *ngIf="item.industry">
                                <h2 *ngIf="BuyerData[_index-1].industry.name != BuyerData[_index].industry.name">{{item.industry.name}}</h2>
                            </ng-container>
                            <buyerCard [Data]="item"></buyerCard>
                        </ng-container>
                    </ng-container>
                    <pagination *ngIf="BuyerPager" [Pager]="BuyerPager" (PageSetEvt)="SetBuyerPage($event)"></pagination>

                </div>
            </div>
        </div>
    </div>
</div>